module.exports = {
    storageItemName: 'userCurrency',

    getUserCurrency: function () {
        return this.getCookie(this.storageItemName);
    },

    getUserCurrencySymbol: function () {
        switch (this.getUserCurrency()) {
            case 'USD':
                return '$';
            case 'GBP':
                return '£';
            default:
                return '€'
        }
    },

    setUserCurrency: function (currency) {
        this.setCookie(this.storageItemName, currency, 1)
        // this.updateSelectionCurrency();

        window.location.reload();
    },

    updateSelectionCurrency: function () {
        let currency = this.getUserCurrency();
        if (!currency) {
            currency = $('.currency-item-selected').data('default')
        }

        $('.currency-item-selected').html('<strong>'+this.getUserCurrencySymbol()+'</strong> ' + currency)
        this.changeCurrencySymbolHtml();
    },

    changeCurrencySymbolHtml: function () {
        let _this = this;

        if (!$('.currency-symbol').length) {
            return;
        }

        $('.currency-symbol').each(function () {
            let currencyElement = $(this);
            let updatedHtml = currencyElement.html().replaceAll('€', _this.getUserCurrencySymbol());
            currencyElement.html(updatedHtml);
        });
    },

    setCookie: function (name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    getCookie: function (name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}